import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solid',
  templateUrl: './solid.component.html',
  styleUrls: ['./solid.component.css']
})
export class SolidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
